/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const add = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M8 14V2m6 6H2"
    />
  </svg>
)
export default add
